import inputTypes from './supported-input-types';

const operators = [{
  label: 'equals',
  key: 'exact',
  supportedTypes: ['string'],
  supportedInputType: inputTypes.MULTIPLE
}, {
  label: 'is not equal',
  key: 'is_not',
  supportedTypes: ['string'],
  supportedInputType: inputTypes.MULTIPLE
}, {
  label: 'equals',
  key: 'exact',
  supportedTypes: ['number'],
  supportedInputType: inputTypes.NUMBER
}, {
  label: 'is not equal',
  key: 'is_not',
  supportedTypes: ['number'],
  supportedInputType: inputTypes.NUMBER
}, {
  label: 'greater than',
  key: 'gt',
  supportedTypes: ['number'],
  supportedInputType: inputTypes.NUMBER
}, {
  label: 'less than',
  key: 'lt',
  supportedTypes: ['number'],
  supportedInputType: inputTypes.NUMBER
}, {
  label: 'starts with',
  key: 'starts_with',
  supportedTypes: ['string', 'text'],
  supportedInputType: inputTypes.TEXT
}, {
  label: 'contains',
  key: 'regex',
  supportedTypes: ['string', 'text'],
  supportedInputType: inputTypes.TEXT
}, {
  label: 'doesn\'t contain',
  key: 'not_regex',
  supportedTypes: ['string', 'text'],
  supportedInputType: inputTypes.TEXT
}, {
  label: 'is after',
  key: 'gt',
  supportedTypes: ['date', 'datetime'],
  supportedInputType: inputTypes.DATE_TIME
}, {
  label: 'is before',
  key: 'lt',
  supportedTypes: ['date', 'datetime'],
  supportedInputType: inputTypes.DATE_TIME
}, {
  label: 'is set',
  key: 'is_set',
  supportedTypes: ['boolean', 'string'],
  tooltip: 'Use this for fields set from contacts',
  supportedInputType: inputTypes.TOGGLE
}, {
  label: 'is not set',
  key: 'is_not_set',
  supportedTypes: ['boolean', 'string'],
  tooltip: 'Use this for fields set from contacts',
  supportedInputType: inputTypes.TOGGLE
}, {
  label: 'is empty',
  key: 'is_empty',
  supportedTypes: ['string'],
  tooltip: 'Use this for system provided data, like email, registered, etc',
  supportedInputType: inputTypes.TOGGLE
}, {
  label: 'is not empty',
  key: 'is_not_empty',
  supportedTypes: ['string'],
  tooltip: 'Use this for system provided data, like email, registered, etc',
  supportedInputType: inputTypes.TOGGLE
}, {
  label: 'Yes',
  key: 'is_not_null',
  supportedTypes: ['null'],
  supportedInputType: inputTypes.TOGGLE
}, {
  label: 'No',
  key: 'is_null',
  supportedTypes: ['null'],
  supportedInputType: inputTypes.TOGGLE
}];

export default operators;